import { SVGProps } from 'react';

export const Accessibility = (props: { className?: string } & SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentcolor"
    data-name="Layer 1"
    width="24"
    height="24"
    viewBox="0 0 7 9"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.5988 2.31997C3.97706 2.31997 4.28369 2.01334 4.28369 1.63508C4.28369 1.25683 3.97706 0.950195 3.5988 0.950195C3.22054 0.950195 2.91391 1.25683 2.91391 1.63508C2.91391 2.01334 3.22054 2.31997 3.5988 2.31997ZM0.527029 2.9218C0.5729 2.73832 0.758823 2.62677 0.942304 2.67264C1.60282 2.83777 2.80767 3.00485 3.5988 3.00485C4.38991 3.00485 5.59477 2.83777 6.25531 2.67264C6.43879 2.62677 6.6247 2.73832 6.67055 2.9218C6.71644 3.10528 6.60487 3.29121 6.42139 3.33707C5.96577 3.45098 5.28253 3.56408 4.62613 3.6304V4.71708C4.62613 5.50822 4.79321 7.05559 4.95833 7.71609C5.00422 7.89958 4.89265 8.08549 4.70917 8.13138C4.52569 8.17723 4.33978 8.06569 4.29393 7.88221C4.17496 7.40642 4.05689 6.52833 3.99206 5.74441H3.20564C3.14078 6.52833 3.02271 7.40642 2.90377 7.88221C2.8579 8.06569 2.67198 8.17723 2.48849 8.13138C2.30502 8.08549 2.19346 7.89958 2.23933 7.71609C2.40235 7.06401 2.56729 5.5476 2.57147 4.74779V3.6304C1.91506 3.56408 1.23183 3.45098 0.776195 3.33707C0.592713 3.29121 0.481159 3.10528 0.527029 2.9218Z"
    />
  </svg>
);
